module.exports = __webpack_public_path__ + "img/404_green.cf54ac07.png";